import React, { useState } from 'react';
import './AuthModal.css';
import { useUser } from '../contexts/UserContext';

const AuthModal = ({ onClose }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [needsRegistration, setNeedsRegistration] = useState(false);
  const [acceptsMarketing, setAcceptsMarketing] = useState(true);
  const { login, register } = useUser();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    
    if (needsRegistration) {
      if (!acceptsMarketing) {
        setError('חובה לאשר קבלת דיוורים');
        return;
      }
      try {
        await register(name, email, acceptsMarketing);
        onClose();
      } catch (err) {
        setError(err.message || 'לא עבד :(');
      }
    } else {
      try {
        await login(email);
        onClose();
      } catch (err) {
        if (err.status === 404) {
          setNeedsRegistration(true);
        } else {
          setError('לא עבד:( נסי שוב)');
        }
      }
    }
  };

  return (
    <div className="auth-overlay" onClick={onClose}>
      <div className="auth-dialog" onClick={e => e.stopPropagation()}>
        <div className="auth-header">
          {needsRegistration ? 'נראה שזו פעם ראשונה שלך כאן' : 'בשביל פעולה זו צריך להתחבר'}
        </div>
        <div className="auth-body">
          {error && <div className="auth-error">{error}</div>}
          <form onSubmit={handleSubmit} className="auth-form">
            {needsRegistration && (
              <label>שם<input value={name} onChange={e=>setName(e.target.value)} required /></label>
            )}
            <label>אימייל<input value={email} onChange={e=>setEmail(e.target.value)} type="email" name="email" required /></label>
            {needsRegistration && (
              <label className="auth-checkbox-label">
                <input type="checkbox" checked={acceptsMarketing} onChange={e=>setAcceptsMarketing(e.target.checked)} required />
                מאשרת דיוורים
              </label>
            )}
            <div className="auth-actions"><button type="submit">התחבר</button></div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
